import { render, staticRenderFns } from "./GoToTopButton.vue?vue&type=template&id=fefbd9aa"
import script from "./GoToTopButton.vue?vue&type=script&lang=ts"
export * from "./GoToTopButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports